//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Web3 from 'web3'
import KothItem from '@/components/landing/KothItem'
import Pageview from '@/mixins/Pageview'

const tokenAbi = require('@/assets/erc20.json')

export default {
  name: 'KothPage',
  components: {
    KothItem
  },
  mixins: [Pageview],
  layout: 'blank',
  auth: false,
  async fetch () {
    await this.$store.dispatch('freelancers/setInitialKoth')
  },
  computed: {
    koth () {
      return this.$store.state.freelancers.koth
    },

    locale () {
      return this.$store.state.i18n.locale
    }
  },
  methods: {
    async claimKoth () {
      try {
        if (process.browser) {
          // check if current user is freelancer
          const freelancer = this.$store.getters['user/getFreelancer']
          if (!freelancer) {
            throw new Error('You need to be logged in as a freelancer')
          }

          // check if 24h passed
          const lastKothAttempt = Date.parse(freelancer.lastKothAttempt)
          if (lastKothAttempt && Date.now() - lastKothAttempt < 86400000) {
            throw new Error('24h have not yet passed since the last attempt')
          }

          if (window.ethereum) {
            window.web3 = new Web3(window.ethereum)
            await window.ethereum.enable()
            const myAccounts = await window.web3.eth.getAccounts()
            const myAddress = myAccounts[0]
            const ctask = new window.web3.eth.Contract(tokenAbi, process.env.ctaskAddress)
            let ctaskBalance = await ctask.methods.balanceOf(myAddress).call()
            ctaskBalance = Math.floor(ctaskBalance / 10 ** 18)
            // console.log(ctaskBalance)
            const odds = (1 - 1 / (1 + Math.sqrt(ctaskBalance / parseFloat(this.koth.price)))) * 100

            const confirmation = await this.$bvModal.msgBoxConfirm(`Your odds are ${odds.toFixed(2)}%`, {
              centered: true
            })

            if (confirmation) {
              const sig = await window.web3.eth.personal.sign('I want to claim CTASK KOTH', myAddress)
              const claimed = await this.$store.dispatch('freelancers/claimKoth', sig)
              if (claimed) {
                await this.$store.dispatch('ui/showNotification', {
                  type: 'success',
                  text: 'You are the new king of the hill!'
                })
              } else {
                await this.$store.dispatch('ui/showNotification', {
                  type: 'warning',
                  text: 'You lost. Try again in 24h.'
                })
              }
            }
          } else {
            throw new Error('Please install an Ethereum-compatible browser or extension like MetaMask to use this page!')
          }
        }
      } catch (e) {
        console.log(e)

        await this.$store.dispatch('ui/showNotification', {
          type: 'danger',
          text: e.message
        })
      }
    }
  }
}
